import type { U3202ModelCapabilities } from '../../u3202AiProvider/utils/U3202CapabilitiesTypes';
import { u3202CapabilitySupported } from '../../u3202AiProvider/utils/u3202CapabilityHelpers';
import { U3204_ALLOWED_MIME_TYPES } from './u3204Constants';

/**
 * Dérive les types MIME autorisés pour les pièces jointes selon les capabilities du modèle.
 * Miroir logique backend u3204ResolveAllowedAttachmentMimeTypes — contrat BL-0157.
 */
export function u3204ResolveAllowedAttachmentMimeTypes(
  capabilities: U3202ModelCapabilities,
  catalogMimeTypes: readonly string[] = U3204_ALLOWED_MIME_TYPES,
): string[] {
  const allowed = new Set<string>();
  if (catalogMimeTypes.includes('text/plain')) {
    allowed.add('text/plain');
  }
  if (u3202CapabilitySupported(capabilities, 'image_input')) {
    for (const mimeType of catalogMimeTypes) {
      if (mimeType.startsWith('image/')) {
        allowed.add(mimeType);
      }
    }
  }
  if (u3202CapabilitySupported(capabilities, 'pdf_input') && catalogMimeTypes.includes('application/pdf')) {
    allowed.add('application/pdf');
  }
  return [...allowed];
}
